module.exports = __webpack_public_path__ + "static/media/Proof_Of_Address.45c71c1a.png";